import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: {}
  },
  mutations: {
    setItem (state, item) {
      const items = { ...state.items }
      items[item.url] = item
      state.items = items
    }
  },
  getters: {
    get: (state, getters, rootState) => (url) => {
      const lang = rootState.lang
      const site = state.items[url]

      if (site) {
        return {
          url: url,
          title: site.translations[lang].title,
          content: site.translations[lang].content
        }
      } else {
        return false
      }
    }
  },
  actions: {
    get ({ commit, state, dispatch, getters }, url) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getSite(token, url)
            .then((res) => {
              commit('setItem', res.body)
              resolve(getters.get(url))
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getPublic ({ commit, state, dispatch, getters }, url) {
      return new Promise((resolve, reject) => {
        API.getPublicSite(url)
          .then((res) => {
            commit('setItem', res.body)
            resolve(getters.get(url))
          })
          .catch((e) => {
            reject(e)
          })
      })
    }
  }
}
